import Page from '../../page';

export default class CareerAbout extends Page {
    constructor(...args) {
        super(...args);

        this._retrieveDOM();
        this._initTls();
    }

    _retrieveDOM() {
        this.dom.views = {};
    }

    init() {
        super.init();
    }

    /**
     * init() {}
     * bind() {}
     * unbind() {}
     * resize(width, height) {}
     * _destroy() {}
     */
}



// WEBPACK FOOTER //
// ./src/js/pages/career/about/career-about.js